import { FC, ReactNode } from 'react';
import { Button } from '@/components/Common';
import { BeatLoader } from 'react-spinners';

type SideListProps = {
  children: ReactNode;
  addBtn?: () => void;
  btnTitle?: string;
  showBtn?: boolean;
  listTopicsStyle?: string;
  isLoading?: boolean;
  optionalBtn?: boolean;
  optionalBtnOnClick?: () => void;
  optionalBtnTitle?: string;
};

const SideList: FC<SideListProps> = ({
  children,
  addBtn,
  showBtn,
  btnTitle,
  isLoading,
  optionalBtn,
  optionalBtnTitle,
  optionalBtnOnClick,
}) => {
  return (
    <div className="flex flex-col items-center h-auto overflow-hidden mb-7 gap-4 pb-4">
      <div className="flex-grow w-full overflow-auto">{children}</div>
      {showBtn && (
        <>
          {isLoading ? (
            <BeatLoader />
          ) : (
            <>
              <Button
                title={btnTitle}
                onClick={addBtn}
                className="w-[calc(100%-50px)]"
              />
              {optionalBtn ? (
                <Button
                  title={optionalBtnTitle}
                  onClick={optionalBtnOnClick}
                  className="w-[calc(100%-50px)] !bg-[#1E1700] text-primary "
                />
              ) : null}
            </>
          )}{' '}
        </>
      )}
    </div>
  );
};

export default SideList;
